import {
  type InvoiceCollection,
  invoiceCollectionSchema,
  type Invoice,
  invoiceSchema, invoiceFilterSchema, type InvoiceFilter,
} from '@/types/Wiser/invoice.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type InvoiceApi = ModelApi<Invoice, InvoiceCollection, InvoiceFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createInvoiceApi(
  client: HttpClient,
  endpoint = '/wiser/factuur',
): InvoiceApi {
  return createRestApi({
    client,
    endpoint,
    schema: invoiceSchema,
    collectionSchema: invoiceCollectionSchema,
    filterSchema: invoiceFilterSchema,
  })
}
